import { render } from "./TaskFormModal.vue?vue&type=template&id=2cb8f116&scoped=true"
import script from "./TaskFormModal.vue?vue&type=script&lang=js"
export * from "./TaskFormModal.vue?vue&type=script&lang=js"

import "./TaskFormModal.vue?vue&type=style&index=0&id=2cb8f116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb8f116"]])

export default __exports__